import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation, I18nextProvider } from 'react-i18next';
import { List, IconButton, Divider, Drawer } from '@mui/material';
import { setToggleSidebar } from 'app/store/features/toggleSidebarSlice';
import { ColorsV2 } from 'app/constants/color';
import i18n from 'app/services/i18n';
import SubMenu from './subMenu';
import { routes as ROUTES } from 'app/routes';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';


const Sidebar = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('translation', { keyPrefix: 'routes' });
  const sidebar = useSelector(state => state.toggleSidebar.isSidebarToggled);
  const routes = [
    {
      icon: <SpaceDashboardOutlinedIcon />,
      selectedIcon: <SpaceDashboardOutlinedIcon />,
      title: t('route_1'),
      link: ROUTES.HOME,
    },
    {
      icon: '/assets/images/identity-white.svg',
      selectedIcon: '/assets/images/identity-white.svg',
      title: t('route_4'),
      iconClosed: '/assets/images/arrow1.svg',
      iconOpened: '/assets/images/arrow2.svg',
      subNav: [
        {
          title: t('route_4_1'),
          link: ROUTES.IDENTITY,
          icon: '/assets/images/data-classification-white.svg',
          selectedIcon: '/assets/images/data-classification-white.svg',
        },
        {
          title: t('route_4_2'),
          link: ROUTES.COMPLIANCE,
          icon: '/assets/images/compliance-white.svg',
          selectedIcon: '/assets/images/compliance-white.svg',
        },
        {
          title: t('route_4_3'),
          link: ROUTES.DOCUMENTATION,
          icon: '/assets/images/milestones_list_white.svg',
          selectedIcon: '/assets/images/milestones_list_white.svg',
        },
      ],
    },
    {
      icon: '/assets/images/add_moderator_white_36dp.svg',
      selectedIcon: '/assets/images/add_moderator_white_36dp.svg',
      title: t('route_12'),
      link: ROUTES.PRIVACY,
    },
    {
      icon: '/assets/images/fact_check_icon_white.svg',
      selectedIcon: '/assets/images/fact_check_icon_white.svg',
      title: t('route_14'),
      link: ROUTES.GAP,
    },
    {
      icon: '/assets/images/messages-white.svg',
      selectedIcon: '/assets/images/messages-white.svg',
      title: t('route_2'),
      link: ROUTES.MESSAGES,
    },
    {
      icon: '/assets/images/settings-white.svg',
      title: t('route_3'),
      selectedIcon: '/assets/images/settings-white.svg',
      // link: '/settings',
      iconClosed: '/assets/images/arrow1.svg',
      iconOpened: '/assets/images/arrow2.svg',
      subNav: [
        {
          title: t('route_3_1'),
          link: ROUTES.USERS,
          icon: '/assets/images/user-white.svg',
          selectedIcon: '/assets/images/user-white.svg',
        },
        {
          title: t('route_3_2'),
          link: ROUTES.SETTINGS,
          icon: '/assets/images/user-setting-white.svg',
          selectedIcon: '/assets/images/user-setting-white.svg',
        },
        {
          title: t('route_3_3'),
          link: ROUTES.ORGANISATION,
          icon: '/assets/images/company-white.svg',
          selectedIcon: '/assets/images/company-white.svg',
        },
      ],
    },
    {
      icon: '/assets/images/logout-white.svg',
      selectedIcon: '/assets/images/logout-white.svg',
      title: t('route_5'),
      link: '/',
    },
  ];

  const drawerWidth = 'calc(12vw + 20px)';

  return (
    <I18nextProvider i18n={i18n}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            display: {xs: 'none', md: 'flex'},
            width: drawerWidth,
            minWidth: '180px',
            maxWidth: '320px',
            boxSizing: 'border-box',
            backgroundColor: ColorsV2.secondary,
            paddingX: '10px',
            paddingY: '20px',
            paddingTop: '64px',
            overflow: 'hidden',
          },
        }}
      >
        {sidebar && (
          <IconButton
            aria-label='menu'
            disableRipple
            onClick={() => {
              dispatch(setToggleSidebar());
            }}
          >
            <img src='/assets/images/menu.svg' />
          </IconButton>
        )}
        <List sx={{ height: '100%', position: 'relative' }}>
          {routes.map((item) => (
            <React.Fragment key={item?.title}>
              {item.link === '/messages' && (
                <Divider
                  variant="middle"
                  sx={{
                    bgcolor: 'gray',
                    height: '2px',
                    borderRadius: '5px',
                    width: '10vw',
                  }}
                />
              )}
              <SubMenu item={item} />
            </React.Fragment>
          ))}
        </List>
      </Drawer>
    </I18nextProvider>
  );
};
export default Sidebar;
